import React, { useState, useEffect } from 'react';
import { Menu, X, Instagram, Facebook } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 lg:py-6">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-2xl lg:text-3xl font-serif tracking-tight text-gray-800 hover:text-rose-400 transition-colors duration-300"
            >
              Motherstore
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('boutique')}
              className="text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 transition-colors duration-300"
            >
              Notre Boutique
            </button>
            <button
              onClick={() => scrollToSection('collections')}
              className="text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 transition-colors duration-300"
            >
              Collections
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 transition-colors duration-300"
            >
              Contact
            </button>
            <div className="flex items-center space-x-4 ml-4 pl-4 border-l border-gray-300">
              <a
                href="https://instagram.com/motherstore.paris"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-rose-400 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com/motherstore.paris"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-rose-400 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-800 hover:text-rose-400 transition-colors duration-300"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('boutique')}
              className="block w-full text-left px-4 py-2 text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 hover:bg-rose-50 rounded transition-colors duration-300"
            >
              Notre Boutique
            </button>
            <button
              onClick={() => scrollToSection('collections')}
              className="block w-full text-left px-4 py-2 text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 hover:bg-rose-50 rounded transition-colors duration-300"
            >
              Collections
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-sm font-medium tracking-wide uppercase text-gray-700 hover:text-rose-400 hover:bg-rose-50 rounded transition-colors duration-300"
            >
              Contact
            </button>
            <div className="flex items-center space-x-4 px-4 pt-3 border-t border-gray-200">
              <a
                href="https://instagram.com/motherstore.paris"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-rose-400 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com/motherstore.paris"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-rose-400 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
